import { render, staticRenderFns } from "./LinkDecisionRationale.vue?vue&type=template&id=0dd0b4d3&scoped=true"
import script from "./LinkDecisionRationale.vue?vue&type=script&lang=js"
export * from "./LinkDecisionRationale.vue?vue&type=script&lang=js"
import style0 from "./LinkDecisionRationale.vue?vue&type=style&index=0&id=0dd0b4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd0b4d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VList,VListItem,VRadio,VRadioGroup})
